import React from 'react';
import { Link } from 'react-router-dom';
import { Calendar, Tag, ArrowRight } from 'lucide-react';
import { mockData } from '../mock';
import SEO from '../components/SEO';

const Blog = () => {
  const { blogPosts } = mockData;

  return (
    <div className="blog-page">
      <SEO 
        title="Birth Stories & Wisdom Blog | Holistic Birth Support Insights"
        description="Expert insights on holistic birth support, herbal medicine, postpartum care, and empowering Black mothers in Central Georgia. Natural healing wisdom for your birth journey."
        keywords="birth blog, doula blog Central Georgia, holistic birth support articles, herbal pregnancy remedies, postpartum care tips, natural birth information"
        url="https://georgia-birth-coach.preview.emergentagent.com/blog"
      />
      {/* Hero Section */}
      <section className="page-hero">
        <div className="container">
          <h1 className="heading-hero">Birth Stories & Wisdom</h1>
          <p className="body-large" style={{maxWidth: '700px', margin: '0 auto'}}>
            Insights on holistic birth support, natural healing, and empowering Black mothers in Central Georgia
          </p>
        </div>
      </section>

      {/* Blog Posts Grid */}
      <section className="blog-grid-section">
        <div className="container">
          <div className="blog-grid">
            {blogPosts.map((post) => (
              <article key={post.id} className="blog-card">
                <Link to={`/blog/${post.slug}`} className="blog-card-image-link">
                  <div className="blog-card-image-container">
                    <img src={post.image} alt={post.title} className="blog-card-image" />
                    <div className="blog-card-category">{post.category}</div>
                  </div>
                </Link>
                <div className="blog-card-content">
                  <div className="blog-card-meta">
                    <span className="blog-meta-item">
                      <Calendar size={14} />
                      {new Date(post.date).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
                    </span>
                  </div>
                  <Link to={`/blog/${post.slug}`}>
                    <h2 className="heading-3 blog-card-title">{post.title}</h2>
                  </Link>
                  <p className="body-small blog-card-excerpt">{post.excerpt}</p>
                  <div className="blog-card-tags">
                    <Tag size={14} />
                    <div className="blog-tags">
                      {post.tags.slice(0, 3).map((tag, index) => (
                        <span key={index} className="blog-tag">{tag}</span>
                      ))}
                    </div>
                  </div>
                  <Link to={`/blog/${post.slug}`} className="blog-read-more">
                    Read Article <ArrowRight size={16} />
                  </Link>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="blog-cta-section">
        <div className="container">
          <div className="cta-content">
            <h2 className="heading-2">Ready to Begin Your Birth Journey?</h2>
            <p className="body-large">Let's discuss how holistic doula support can serve you and your family.</p>
            <Link to="/contact" className="btn-primary">Schedule Free Consultation</Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Blog;
